import { render, staticRenderFns } from "./controller.vue?vue&type=template&id=6a1b34b9&scoped=true"
import script from "./controller.vue?vue&type=script&lang=js"
export * from "./controller.vue?vue&type=script&lang=js"
import style0 from "./controller.vue?vue&type=style&index=0&id=6a1b34b9&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1b34b9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a1b34b9')) {
      api.createRecord('6a1b34b9', component.options)
    } else {
      api.reload('6a1b34b9', component.options)
    }
    module.hot.accept("./controller.vue?vue&type=template&id=6a1b34b9&scoped=true", function () {
      api.rerender('6a1b34b9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/design/layout-preview/controller.vue"
export default component.exports